/** Family 2: the staggered cantilever (S-shelf) — David's reference photo (plan §4.7). */
import jointsJson from './joints.json' with { type: 'json' };
import type { Family } from '../registry-types';
import { STAGGERED_DEFINITION } from './definition';
import { generateStaggered } from './generate';
import { checkStaggeredParams, STAGGERED_INTAKE, staggeredDesignFromFit, staggeredFitSummary, type StaggeredFitParams } from './intake';
import { applyPreset, createStaggered, paramsOf, setTiers, type StaggeredPresetKey, type TierEnds } from './design';
import { setBaseParam } from '../base';

export const STAGGERED_FAMILY: Family<StaggeredFitParams> = {
  definition: STAGGERED_DEFINITION,
  jointsJson,
  intake: STAGGERED_INTAKE,
  generate: (design, stock, construction) => generateStaggered(design, stock, construction),
  checkParams: checkStaggeredParams,
  designFromFit: staggeredDesignFromFit,
  fitSummary: staggeredFitSummary,
  create: (presetId?: string) => createStaggered((presetId as StaggeredPresetKey) ?? 'david'),
  setParam: (design, key, value) => {
    // an edit replaces the fitted layout, so the post-fit notes no longer apply
    const { buildableChanges: _drop, ...rest } = design.params ?? {};
    void _drop;
    design = { ...design, params: rest };
    const b = setBaseParam(paramsOf(design), key, value);
    if (b) return { ...design, params: b as unknown as Record<string, unknown> };
    if (key === 'tiers') return setTiers(design, Number(value));
    if (key === 'preset') return value === 'alternate' ? applyPreset(design, 'alternate') : { ...design, params: { ...paramsOf(design), preset: 'free' } as unknown as Record<string, unknown> };
    if (key === 'tierEnds') return { ...design, params: { ...paramsOf(design), tierEnds: (value as TierEnds[]).map((e) => ({ ...e })), preset: 'free' } as unknown as Record<string, unknown> };
    return { ...design, params: { ...paramsOf(design), [key]: value } as unknown as Record<string, unknown> };
  },
};

export * from './definition';
export * from './design';
export * from './generate';
export * from './intake';
